module.exports = __webpack_public_path__ + "static/media/qora.7171c65e.png";